import React, { createContext, useContext } from "react";
import { Button, notification, Space } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Modal from "antd/lib/modal/Modal";

import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { observer } from "mobx-react-lite";
import { Cpu } from "react-feather";
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
export const AdvanceQueryDialog = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  return (
    <Modal
      visible={monthlyPerformanceStore.showAdvanceQueryDialog}
      title="Advance Query Editor"
      onCancel={() => {
        monthlyPerformanceStore.showAdvanceQueryDialog = false;
      }}
      centered={true}
      mask={false}
      footer={
        <Space>
          <Button
            type="link"
            onClick={() => {
              monthlyPerformanceStore.showAdvanceQueryDialog = false;
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            disabled={monthlyPerformanceStore.sqlCommand.length === 0}
            loading={monthlyPerformanceStore.isQuerying}
            onClick={async () => {
              try {
                const retVal = await monthlyPerformanceStore.runAdvanceQuery();

                if (retVal) {
                  const { displayColumns, data } = retVal;
                  console.log({
                    displayColumns,
                    data,
                  });
                  monthlyPerformanceStore.queryGrid.current.api.setGridOption(
                    "columnDefs",
                    displayColumns
                  );
                  monthlyPerformanceStore.queryResults = data;
                } else {
                  monthlyPerformanceStore.showEmpty = true;
                }
                monthlyPerformanceStore.showAdvanceQueryDialog = false;
              } catch (error) {
                console.log(error);
                monthlyPerformanceStore.showEmpty = true;
                monthlyPerformanceStore.queryResults.clear();
                const { response } = error;
                if (response?.text) {
                  notification.error({
                    message: "SPARS Vulnerability Manager",
                    description: response?.text,
                  });
                } else {
                  notification.error({
                    message: "SPARS Feeedback Manager",
                    description: error.message,
                  });
                }
              }
            }}
          >
            <Cpu size={16} style={{ marginRight: "5px", marginTop: "5px" }} />{" "}
            Run
          </Button>
        </Space>
      }
      width="50%"
    >
      <TextArea
        autoFocus
        className="code"
        style={{
          borderLeft: "4px solid #FAA632",
          minHeight: "130px",
          backgroundColor: "#111",
          padding: "20px",
          color: "white",
          fontFamily: "courier-new,courier,monospace!important",
          fontSize: "18px",
        }}
        value={monthlyPerformanceStore.sqlCommand}
        onChange={({ target }) => {
          monthlyPerformanceStore.sqlCommand = target.value;
        }}
        rows={10}
      ></TextArea>
    </Modal>
  );
});

